<!--
 * @Description: 随机试卷
 * @Author: PF
 * @Date: 2023-09-12 14:46:16
 * @LastEditors: PF
 * @LastEditTime: 2024-08-01 16:02:51
-->
<template>
  <el-table :data="tableData" height="100%" border stripe>
    <el-table-column label="序号" type="index" width="55" fixed align="center" />
    <el-table-column label="题型" fixed prop="txid" align="center" show-overflow-tooltip>
      <template #default="scope">
        <span v-for="item in txData" :key="item.id">
          <span v-if="scope.row.txid === item.id">{{ item.bt }}</span>
        </span>
      </template>
    </el-table-column>
    <el-table-column label="数量" prop="sl" align="center" show-overflow-tooltip />
    <el-table-column label="难度" prop="nd" align="center" show-overflow-tooltip>
      <template #default="scope">
        <span style="width:150px">{{scope.row.ndsj}}</span>
        <span class="ml5 mr5" v-if="scope.row.ndsj !== scope.row.ndxj">至</span>
        <span style="width:150px" v-if="scope.row.ndsj !== scope.row.ndxj">{{scope.row.ndxj}}</span>
      </template>
    </el-table-column>
    <el-table-column label="每题分数" prop="mtfs" align="center" show-overflow-tooltip />
  </el-table>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadSelect } from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'

const props = defineProps({ row: { type: Array, required: true } })

const txData = ref([]) // 题型
const sjlxData = ref({ list: [] })
const tableData = ref([])
watch(
  () => props.row,
  () => {
    if (props.row.length) {
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshijihua/shijuanleibie', data: sjlxData })
      loadZiDianSelect('题型', txData)
      tableData.value = props.row
    }
  },
  { deep: true, immediate: true }
)

</script>
